/* global $ */
import Basic from './Basic'
import { compile } from '@/core/index'

export default class Unit extends Basic {
  constructor(el, opt) {
    super(el, opt)
    this.obj = {}
    this.init()
  }

  init() {
    const el = this.$el
    this.settings.block = 'unit'
    if (!el || !el.length) return console.error(`选择器${this.el}不存在!初始化前,确认此选择器是否已挂载.`)
    const obj = compile.input(el[0], { ...this.settings })
    el.after(obj.outer)
    el.detach()
    this.obj = obj
  }
}
